export default function AppRedirectPage() {
  window.location.replace("https://drahim.page.link/Hv1E");
  return null;
}
